import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import { useHistory } from 'react-router-dom';
import ROUTES from '@src/constants/route';
import NotificationDialogV4 from '@src/components/NotificationDialogV4';
import IconUpgrade from '@src/assets/images/icon-paid-package.png';
import { TOP_UP_PACKAGE_CODES } from '@src/constants/package';
import { LINK_GUIDE_NOT_ENOUGH_CREDITS } from '@src/constants/tts';

const OutOfCreditsVip = ({ open, onClose, warningOneTimeCredits }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleBuyMore = () => {
    const url = `${ROUTES.PAYMENT}?package=${TOP_UP_PACKAGE_CODES[2]}`;
    history.push(url);
  };

  const renderBuyMoreButton = () => (
    <Button variant="contained" onClick={handleBuyMore}>
      {t('buyMoreChar')}
    </Button>
  );

  const warning = warningOneTimeCredits
    ? t('warningOnetimeCreditsWithVipPkg', {
        link: LINK_GUIDE_NOT_ENOUGH_CREDITS,
      })
    : '';

  return (
    <NotificationDialogV4
      image={IconUpgrade}
      title={t('outOfCredits')}
      description={t('descriptionOutOfCreditsVip', {
        warning,
      })}
      actionComponent={renderBuyMoreButton()}
      open={open}
      onClose={onClose}
    />
  );
};

export default OutOfCreditsVip;
